import { type AxiosError, type AxiosRequestConfig } from "axios";
import { apiAxiosInstance } from "~/api";

export const httpClient = async <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const { data } = await apiAxiosInstance.request<T>({
    // axios writes arrays as `type[]=A&type[]=B`, which Spring doesn't bind to
    // a List parameter; it expects the key repeated.
    paramsSerializer: { indexes: null },
    ...config,
    ...options,
  });

  return data;
};

export type ErrorType<TError> = AxiosError<TError>;
export type BodyType<TBody> = TBody;
